export const TYPE_RESPONSIBLE = 'responsible';
export const TYPE_RESPONSIBLE_FOR_PICKING = 'responsible_picking';
